import { render, staticRenderFns } from "./LogsPage.vue?vue&type=template&id=7ba2aa9d&"
import script from "./LogsPage.vue?vue&type=script&lang=js&"
export * from "./LogsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports